<template>
  <b-tabs>
    <b-tab title="Calculator">
      <b-container>
        <b-row class="mb-2">
          <b-col></b-col>
          <b-col class="text-right">
            <b-button size="sm" @click="$emit('reset')" :disabled="!hasLineObj" class="mr-2">Reset</b-button>
            <b-button size="sm" variant="primary" :disabled="!hasLineObj" @click="updateLine">Update Line</b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label-cols="5" label-align="right" label="Qty">
              <b-input-group size="sm">
                <b-form-input v-model.number="lineObj.quantity" :disabled="!hasLineObj" @input="updateMarginPercent" type="number" />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label-cols="5" label-align="right" label="Sales Price">
              <b-input-group :prepend="lineObj.currencySymbol ? lineObj.currencySymbol : '$'" size="sm">
                <b-form-input v-model.lazy="lineObj.price" :disabled="!hasLineObj" @input="updateMarginPercent" />
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label-cols="5" label-align="right" label="Cost">
              <b-input-group :prepend="'$'" size="sm">
                <b-form-input v-if="isPrice" :value="lineObj.price" disabled />
                <b-form-input v-else :value="lineObj.cost" disabled />  
                <b-input-group-append v-if="lineObj.costComputation">
                  <b-button variant="primary" id="tooltip-button-not-interactive"><i class="fa fa-info" size="sm"></i></b-button>
                  <b-tooltip target="tooltip-button-not-interactive" noninteractive>
                    <span v-html="lineObj.costComputation"></span>
                  </b-tooltip>
                </b-input-group-append>
                
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label-cols="5" label-align="right" label="Total Price">
              <b-input-group :prepend="lineObj.currencySymbol ? lineObj.currencySymbol : '$'" size="sm">
                <b-form-input disabled :value="formatMoney(totalPrice)" />
              </b-input-group>
            </b-form-group>
          </b-col>         
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label-cols="5" label-align="right" label="Total Cost">
              <b-input-group :prepend="'$'" size="sm">
                <b-form-input disabled :value="formatMoney(totalCost)" />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label-cols="5" label-align="right" label="Conv. Price">
              <b-input-group :prepend="'$'" size="sm">
                <b-form-input disabled :value="lineObj.convertedPrice" />
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col></b-col>
          <b-col>
            <b-form-group label-cols="5" label-align="right" label="Conv. Total">
              <b-input-group :prepend="'$'" size="sm">
                <b-form-input disabled :value="formatMoney(lineObj.convertedTotal)" />
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label-cols="5" label-align="right" label="Profit">
              <b-input-group :prepend="'$'" size="sm">
                <b-form-input disabled :value="formatMoney(profit)" />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label-cols="5" label-align="right" label="Margin">
              <b-input-group prepend="%" size="sm">
                <b-form-input v-model="marginPercent" :disabled="!lineObj" @input="updateCalculator" type="number" />
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-container>
    </b-tab>
  </b-tabs>
</template>

<script>
import debounce from 'lodash/debounce';

export default {
  props: {
    lineObj: {
      type: Object,
      default: () => {},
    },
    isPrice: {
      type: Boolean,
      default: false
    },
    exchangeRate: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      marginPercent: '',
      hasLineObj: false,
      money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false
        }
    }
  },
  computed: {
    totalCost() {
      if(Object.keys(this.lineObj).length > 0) {
        var totalCost = this.lineObj.quantity * this.lineObj.cost;
        return totalCost;
      } else {
        return 0.00;
      }
    },
    totalPrice() {
      if(Object.keys(this.lineObj).length > 0) {
        var totalPrice = this.lineObj.quantity * this.lineObj.price;
        return totalPrice;
      } else {
        return 0.00;
      }
    },
    profit() {
      return this.lineObj.convertedTotal - this.totalCost;
    },
  },
  methods: {
    onMarginPercentChange(newValue) {
      setTimeout(() => {
        let temp = 1 - (newValue / 100);
        this.lineObj.price = (this.cost / temp).toFixed(4);
        this.lineObj.convertedPrice = this.lineObj.price * this.exchangeRate;
        this.lineObj.convertedTotal = this.lineObj.convertedPrice * this.lineObj.quantity;
      }, 1000);
    },
    updateMarginPercent() {
      this.marginPercent = ((this.profit/this.lineObj.convertedTotal) * 100).toFixed(2);
    },
    updateCalculator: debounce(function () {
      let temp1 = 1 - (this.marginPercent / 100)
      this.lineObj.price = (this.lineObj.cost / temp1).toFixed(4);
      this.lineObj.convertedPrice = this.lineObj.price * this.lineObj.exchangeRate;
      this.lineObj.convertedTotal = this.lineObj.convertedPrice * this.lineObj.quantity;
    }, 750),
    updateLine() {
      this.$emit('updateLine', this.lineObj);
    },
    formatMoney(val) {
      try {
        var str = Number(val).toFixed(2).toString().split('.');
        if (str[0].length >= 3) {
          str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
        }
        if (str[1]) {
          if (str[1].length < 2) {
            while (str[1].length < 2) { str[1] = str[1] + "0"; }
          } else if (str[1].length > 2) {
            str[1] = str[1].substring(0, 2)
          }
        }
        return str.join('.');
      } catch {
        return val;
      }
    }
  },
  watch: {
    lineObj() {
      if(!this.hasLineObj) this.hasLineObj = true;

      this.updateMarginPercent();
    },
  },
}
</script>